const routes = {
  login: '/login',
  logout: '/logout',
  root: '/'
}

export default routes
